import styled from "styled-components";

export const DishesCardWrapper = styled.div`
  .svgStandard {
    fill: var(--titleWeek);
  }

  .svgHighlight {
    fill: white;
  }

  .btn-standard {
    background: var(--productListBtn);
  }

  .btn-highlight {
    background: var(--productListBtnHighlight);
  }

  .text-standard {
    font-weight: bold;
    color: var(--productTitle);
    font-size: 14px;
  }

  .text-highlight {
    color: white;
    font-weight: bold;
    font-size: 14px;
  }
  p {
    color: var(--checkout-product-descr);
    font-size: 14px;
  }
  h5 a {
    color: #2d2b2d;
    font-size: 24px;
  }
`;
